import React from 'react';
import _ from 'lodash';

import config from '../../config';
import { JourneySelectorTypes } from '../../constants/AppConstants';

import JourneySelectorOpen from './JourneySelectorOpen';
import JourneySelectorClosed from './JourneySelectorClosed';


function JourneySelector ({ search, searchAttempted, ...props }) {
    if (config.get('journeySelectorType') === JourneySelectorTypes.OPEN) {
        return (
            <JourneySelectorOpen search={ search } searchAttempted={ searchAttempted } { ...props } />
        );
    } else if (config.get('journeySelectorType') === JourneySelectorTypes.CLOSED) {
        const newProps = _.omit(props, ['enableStationFinder']);

        const options = search.getRouteOptions();

        return (
            <JourneySelectorClosed search={ search }
                                   options={ options }
                                   { ...newProps } />
        );
    }
    return null;
}


JourneySelector.propTypes = Object.assign({},
    JourneySelectorOpen.propTypes,
    JourneySelectorClosed.propTypes
);


export default JourneySelector;



// WEBPACK FOOTER //
// ./src/components/search/JourneySelector.js